import { createSelector } from 'reselect';
import { State } from '../../types/mx/reducers';

export const nationalitiesSelector = createSelector(
    (state: State) => state.catalogs.countriesWithNationalities,
    (list) =>
        list.map((i) => ({
                id: i.id,
                value: i.payload,
        }))
);
